<template>
  <div>
    <v-layout column justify-center align-content-center fill-height>
      <help-button>
        <div>
          <h3>Lesson Section: </h3>
          <p>
            1. Read the lesson primer
          </p>
          <p>
            2. Review each vocabulary card and then click "Add to Reviews" to add that vocabulary to your review queue. Each review question must be answered correctly three times (non-consecutively does count) to advance to the next lesson.
          </p>
        </div>
      </help-button>

      <!-- Lesson Text -->
      <v-layout justify-center v-if="!lessonReviewed">
        <v-card class="elevation-1" max-width="90%">
          <v-card-title primary-title class="headline">{{
            lesson_Title
          }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-flex v-html="body" style="font-family: sans-serif"></v-flex>
          </v-card-text>
        </v-card>
      </v-layout>

      <!-- Vocab Introduction Tiles -->
      <v-layout justify-center column align-content-center v-else>
        <div v-for="(word, i_w) in levelVocab" class="pa-3 ma-3">
          <v-card class="elevation-1 pa-3" max-width="90%">
            <v-card-title primary-title class="headline">{{
              word.emiWord
            }}</v-card-title>
            <v-divider></v-divider>
            <div>
              <span v-for="(t, i_t) in word.translations">
                {{ t.translation }}
                <span v-if="i_t + 1 < word.translations.length">,&nbsp;</span>
              </span>
            </div>
            <v-card-actions>
              <v-btn flat @click="wordToReviewQueue(word, i_w)"
                >Add To Reviews</v-btn
              >
            </v-card-actions>
          </v-card>
        </div>
        <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3">
          <!-- Show when user has added all vocab to their queue -->
          <v-flex v-if="levelVocab.length <= 0">
            <h1>Done with lessons for now</h1>
            <v-btn outline large round to="/">Return</v-btn>
          </v-flex>
        </v-card>
      </v-layout>
    </v-layout>

    <!-- Mark Lesson Complete Button -->
    <v-layout justify-center>
      <v-btn
        v-if="!lessonReviewed"
        @click="complete"
        max-width="100px"
        color="primary"
        >Start reviews for {{ lesson_Title }}
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import HelpButton from "../components/HelpButton.vue";
export default {
  components: {
    HelpButton,
  },
  data() {
    return {
      lesson_Title: this.$store.getters.currentLesson.title,
      body: this.$store.getters.currentLesson.lessonEditor,
      levelVocab: this.$store.getters.unstudiedVocab,
      lessonComplete: false,
    };
  },
  methods: {
    complete: function () {
      this.$store.dispatch("finishLesson");
      this.$store.dispatch("getLessonQuestions");
    },
    wordToReviewQueue: function (word, index) {
      //vuex action: add this word to the review queue
      this.$store.dispatch("addToVocabQueue", word);
      this.levelVocab.splice(index, 1);
    },
  },
  computed: {
    lessonReviewed: function () {
      return this.$store.state.user.lessonReviewed;
    },
  },
};
</script>


<style scoped>
a {
  text-decoration: none;
}
.hintText {
  margin-bottom: 0 !important;
  color: white;
}
.rounded-card {
  border-radius: 10px;
  width: 90vw;
  max-width: 800px;
  margin: 10px auto !important;
}
</style>
